import React from 'react'
import { Button } from 'react-bootstrap'
import { EnvelopeFill } from 'react-bootstrap-icons'
import useDiscussExperience from '../../experience/use-discuss-experience'

const MessageButton = ({
    course = {},
    userId
}) => {
    const { showDiscussionConfiguration } = useDiscussExperience({ experience: course, users: [ course.facilitatorId, userId ] })
    return (
        <Button
            variant='link'
            onClick={() => showDiscussionConfiguration()}
        >
            <EnvelopeFill size={20} />
        </Button>
    )
}

export default MessageButton
